import React from 'react';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { MaintenanceMeaning } from './components/MaintenanceMeaning';
import { TrustMoment } from './components/TrustMoment';
import { TheDifferentiator } from './components/TheDifferentiator';
import { Services } from './components/Services';
import { SocialProof } from './components/SocialProof';
import { ServiceConvenience } from './components/ServiceConvenience';
import { FAQ } from './components/FAQ';
import { WhoWeAre } from './components/WhoWeAre';
import { LocationMap } from './components/LocationMap';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <div className="min-h-screen bg-brand-light font-sans selection:bg-brand-accent selection:text-white" data-id="element-0" data-mp="2wip6b2g4hi4x">
      <TopBar data-id="element-1" data-mp="28sl0cofgp6ar" />
      <main data-id="element-2" data-mp="28s2ynca15zvg">
        <HeroSection data-id="element-3" data-mp="23vkw8j26adma" />
        <TrustBar data-id="element-4" data-mp="23w4drynwuzzs" />
        <MaintenanceMeaning data-id="element-5" data-mp="23ujlkfp2jt53" />
        <SocialProof data-id="element-6" data-mp="23t8h0dnsuhcx" />
        <TrustMoment data-id="element-7" data-mp="3ik7gihlkcdr6" />
        <TheDifferentiator data-id="element-8" data-mp="3ikqy1x7ax04o" />
        <Services data-id="element-9" data-mp="3ijfvg0pldyf5" />
        <ServiceConvenience data-id="element-10" data-mp="3ihv0wb3a2fha" />
        <FAQ data-id="element-11" data-mp="3mlaxj7fckftz" />
        <WhoWeAre data-id="element-12" data-mp="3mkrefndynled" />
        <LocationMap data-id="element-13" data-mp="3mk852v2dm5by" />
        <FinalCTA data-id="element-14" data-mp="3mjpyb4i388ps" />
      </main>
      <footer className="border-t border-gray-800 bg-brand-dark py-8 text-center text-sm text-gray-500" data-id="element-15" data-mp="3rcj5s04xxv5k">
        <div className="mx-auto max-w-6xl px-4" data-id="element-16" data-mp="5opiv1o0k3w">
          <a href="https://www.lancerservice.com" target="_blank" rel="noopener noreferrer" className="text-[24px] font-semibold text-gray-300 transition-colors hover:text-brand-accent" data-id="element-17" data-mp="5gbgztt38r4">
            www.lancerservice.com
          </a>
          <p className="mt-3 font-medium text-gray-400" data-id="element-18" data-mp="38k6v8q44vnkc">
            Mon – Fri 7:00am – 5:00pm ·{' '}
            <a href="https://google.com/maps?um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KbmDlI9Q1feHMfLJfRWdix_1&daddr=270+E+8th+St,+St+Paul,+MN+55101" target="_blank" rel="noopener noreferrer" className="underline transition-colors hover:text-brand-accent" data-id="element-19" data-mp="3dmfn1j59sjkv">
              270 E 8th St, St Paul, MN 55101
            </a>
          </p>
          <p className="mt-3" data-id="element-20" data-mp="3uc9inv5c9kir">
            © {new Date().getFullYear()} Lancer Service. All rights reserved.
          </p>
          <p className="mt-1" data-id="element-21" data-mp="d2biphy7dzw7">Independent Auto Repair · St. Paul, MN</p>
        </div>
      </footer>
    </div>;
}